<template>
  <base-page-layout title="Encartes">
    <encartes-ativos :units="units" />
    <div class="booklets-tables">
      <mf-card-container
        v-if="isFranchisee"
        v-model="searchFranchiseBooklets"
        title="Encartes da rede"
        placeholder="Buscar encarte"
        use-search
        use-status-filter
        hide-content-padding
        :items-filter="franchiseItemsFilter"
        @status-filter="getFranchiseFilterResult"
      >
        <tabela-encartes class="table" :search="searchFranchiseBooklets" :units="units" franchise-table :statusToSearch="statusToSearchFranchise" />
      </mf-card-container>
      <mf-card-container
        v-model="searchMyBooklets"
        title="Meus encartes"
        placeholder="Buscar encarte"
        use-search
        use-status-filter
        hide-content-padding
        :items-filter="itemsFilter"
        @status-filter="getFilterResult"
      >
        <tabela-encartes class="table" :search="searchMyBooklets" :is-franchise="isFranchise" :statusToSearch="statusToSearch" />
      </mf-card-container>
    </div>
  </base-page-layout>
</template>

<script>
import { QUERY_UNITS } from '@/modules/configuracoes/lojas/graphql'
import { getStatusLabel } from '@/config/helpers.js'

export default {
  components: {
    BasePageLayout: () => import('@/components/BasePageLayout.vue'),
    EncartesAtivos: () => import('@/modules/mobile/encartes/views/pages/EncartesAtivos.vue'),
    TabelaEncartes: () => import('@/modules/mobile/encartes/views/pages/TabelaEncartes.vue'),
  },
  data: () => ({
    searchFranchiseBooklets: '',
    searchMyBooklets: '',
    statusToSearch: ['ACTIVE', 'SCHEDULED', 'FINISHED', 'DRAFT', 'PAUSED'],
    statusToSearchFranchise: ['ACTIVE', 'SCHEDULED', 'PAUSED', 'FINISHED'],
    itemsFilter: [
      { label: getStatusLabel('ACTIVE').text, value: 'ACTIVE', color: getStatusLabel('ACTIVE').color, active: true },
      { label: getStatusLabel('SCHEDULED').text, value: 'SCHEDULED', color: getStatusLabel('SCHEDULED').color, active: true },
      { label: getStatusLabel('FINISHED').text, value: 'FINISHED', color: getStatusLabel('FINISHED').color, active: true },
      { label: getStatusLabel('PAUSED').text, value: 'PAUSED', color: getStatusLabel('PAUSED').color, active: true },
      { label: getStatusLabel('DRAFT').text, value: 'DRAFT', color: getStatusLabel('DRAFT').color, active: true },
    ],
  }),
  computed: {
    isFranchise() {
      return this.$getLoggedUser().is_franchise
    },
    isFranchisee() {
      return this.$getLoggedUser().is_franchisee
    },
    franchiseItemsFilter() {
      const size = this.itemsFilter.length
      return this.itemsFilter.slice(0, size - 1)
    },
  },
  apollo: {
    units: {
      query: QUERY_UNITS,
      fetchPolicy: 'network-only',
    },
  },
  methods: {
    getFranchiseFilterResult(value) {
      const status = ['ACTIVE', 'SCHEDULED', 'PAUSED']
      this.statusToSearchFranchise = value.length ? value : status
    },
    getFilterResult(value) {
      const status = ['ACTIVE', 'SCHEDULED', 'FINISHED', 'DRAFT', 'PAUSED']
      this.statusToSearch = value.length ? value : status
    },
  },
}
</script>

<style lang="scss" scoped>
.booklets-tables {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  .table {
    padding-top: 50px;
  }
}
::v-deep .table-header-actions {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
}
</style>
